import { PortalPageType } from '@/types/Auth';
import { Media } from '@/types/Media';

const QR: {
  [type in PortalPageType]: (host: string, media: Media) => string;
} = {
  [PortalPageType.PORTAL]: generateLink4portal,
  [PortalPageType.PUBLIC]: generateLink4public,
};

export function link(host: string, media: Media, pageType: PortalPageType): string {
  return QR[pageType](host, media);
}

export function qr(host: string, media: Media, pageType: PortalPageType): string {
  return `${host}api/v1.0/qrcode/${media.id}/${pageType}`;
}

function generateLink4portal(host: string, media: Media) {
  return `${host}media/${media.id}`;
}

function generateLink4public(host: string, media: Media) {
  return `${host}/media/${media.id}`;
}
